import { Box, Stack } from '@mui/material'
import { useFormContext } from '../../context/form'
import FormCheckbox from '../FormCheckbox'
import FormSelect from '../FormSelect'
// import useGetLenders from "../../hooks/useGetLenders";

interface FormItem {
  label: string
  value: string
}

const otherFeatures = [
  {
    label: 'Offset',
    value: 'Offset',
  },
  {
    label: 'Flexible (No ERC)',
    value: 'Flexible (No ERC)',
  },
  {
    label: 'Help to Buy',
    value: 'Help to Buy',
  },
  {
    label: 'First Time Buyer',
    value: 'First Time Buyer',
  },
  {
    label: 'New Build',
    value: 'New Build',
  },
]
interface MortgageFiltersProps {
  mortgageTypes: FormItem[]
}

const MortgageFilters: React.FC<MortgageFiltersProps> = ({ mortgageTypes }) => {
  const { form, lenders } = useFormContext()

  return (
    <Stack spacing={1}>
      <Box
        padding="0px 34px"
        marginTop="20px !important"
        marginBottom="20px !important"
        sx={{
          fontSize: {
            xs: '16px !important',
            md: '18px !important',
          },
        }}
      >
        <Stack spacing={4}>
          <FormCheckbox
            name="mortgageClass"
            label="Mortgage Type"
            control={form.control}
            items={mortgageTypes}
          />

          <FormSelect
            variant="outlined"
            name="lender"
            control={form.control}
            label="Lenders"
            items={[{ label: '----Select Lender----', value: '' }].concat(
              lenders!.map((lender) => ({
                label: lender.Name,
                value: lender.Code,
              }))
            )}
          />

          <FormCheckbox
            name="initialPeriod"
            label="Initial Period"
            control={form.control}
            items={[
              {
                label: '2 years',
                value: '2 years',
              },
              {
                label: '3 years',
                value: '3 years',
              },
              {
                label: '5 years',
                value: '5 years',
              },
              {
                label: '10 years',
                value: '10 years',
              },
              // {
              //   label: "Lifetime",
              //   value: "Lifetime",
              // },
            ]}
          />

          <FormCheckbox
            name="fees"
            label="Fees"
            control={form.control}
            items={[
              {
                label: 'Add fees',
                value: 'Add fees',
              },
              {
                label: 'Pay fees',
                value: 'Pay fees',
              },
              {
                label: 'No fees',
                value: 'No fees',
              },
              {
                label: 'Free Mortgage Valuation',
                value: 'Free Mortgage Valuation',
              },
            ]}
          />

          <FormCheckbox
            name="region"
            label="Region"
            control={form.control}
            items={[
              {
                label: 'England',
                value: 'XE',
              },
              {
                label: 'Scotland',
                value: 'XS',
              },
              {
                label: 'Wales',
                value: 'XW',
              },
              {
                label: 'Northern Ireland',
                value: 'XI',
              },
            ]}
          />

          <FormCheckbox
            name="others"
            label="Other Features"
            control={form.control}
            items={otherFeatures}
          />
        </Stack>
      </Box>
    </Stack>
  )
}

export default MortgageFilters
